import(/* webpackMode: "eager" */ "c:\\projects\\front-next\\my-project\\src\\app\\not-found.tsx");
